import { Controller } from "@hotwired/stimulus"

// design_system layout uses document scroll at lg+ and #main-content as the
// scrollport below lg. Transfer scroll position when crossing that breakpoint
// so a mid/bottom scroll does not leave a clipped gray void.
const LG_BREAKPOINT = "(min-width: 1024px)"

export default class extends Controller {
  connect() {
    this.mediaQuery = window.matchMedia(LG_BREAKPOINT)
    this.desktop = this.mediaQuery.matches
    this.boundSync = this.syncScrollport.bind(this)
    this.mediaQuery.addEventListener("change", this.boundSync)
  }

  disconnect() {
    this.mediaQuery.removeEventListener("change", this.boundSync)
  }

  mainElement() {
    return document.getElementById("main-content")
  }

  syncScrollport(event) {
    const isDesktop = event.matches
    const main = this.mainElement()
    if (!main || isDesktop === this.desktop) {
      this.desktop = isDesktop
      return
    }

    if (this.desktop && !isDesktop) {
      const y = window.scrollY
      window.scrollTo(0, 0)
      main.scrollTop = y
    } else {
      const y = main.scrollTop
      main.scrollTop = 0
      window.scrollTo(0, y)
    }

    this.desktop = isDesktop
  }
}
